import { swSettings } from "app/common/services/swSettings";
import { DeviceService } from "app/pages/app-intelligence/common-components/device-picker/DeviceService";
import { AppStoreID, AppStoreName } from "app/pages/app-intelligence/constants";
import type { IFilterProps } from "app/pages/app-intelligence/types";

const getIosDevicesWithoutAllDevices = () => DeviceService.getIosDevices().slice(-2);
const getAndroidDevices = () => DeviceService.getAndroidDevices();
const getAndroidPhoneDevice = () => getAndroidDevices().slice(1, 2);

const pagesFilters = {
    digitalsuite_app_appperformance: (stateName, params): IFilterProps => {
        return {
            duration: {
                disableDurationFilter: true,
            },
            countries: {
                hasLimitedCountries: false,
                disableCountryFilter: false,
            },
            device: {
                disableDeviceFilter: true,
            },
        };
    },
    digitalsuite_app_apprankinghistory: (stateName, params): IFilterProps => {
        return {
            duration: {
                disableDurationFilter: false,
                presentDurationAsList: true,
            },
            countries: {
                hasLimitedCountries: true,
                disableCountryFilter: false,
            },
            device: {
                disableDeviceFilter: true,
                iosDevices: getIosDevicesWithoutAllDevices(),
                androidDevices: getAndroidPhoneDevice(),
            },
        };
    },
    digitalsuite_app_apprankingdaily: (stateName, params): IFilterProps => {
        return {
            duration: {
                disableDurationFilter: true,
                presentFakeDurationFilterSingleDay: true,
            },
            countries: {
                removeCountryFilter: true,
            },
            device: {
                disableDeviceFilter: true,
                iosDevices: getIosDevicesWithoutAllDevices(),
                androidDevices: getAndroidPhoneDevice(),
            },
        };
    },
    digitalsuite_app_usersengagement: (stateName, params): IFilterProps => {
        const { IsNewEngagementIosMetrics } = swSettings.current.resources;
        const isIsoApp = params?.appId?.startsWith?.(AppStoreID.APPLE);
        const isOldIosMetrics = IsNewEngagementIosMetrics ? !IsNewEngagementIosMetrics : isIsoApp;

        return {
            duration: {
                disableDurationFilter: false,
                disableWindowDuration: isOldIosMetrics,
            },
            countries: {
                hasLimitedCountries: false,
                disableCountryFilter: isOldIosMetrics,
            },
            device: {
                disableDeviceFilter: true,
            },
        };
    },
    digitalsuite_app_storeengagement: (stateName, params): IFilterProps => {
        return {
            duration: {
                disableDurationFilter: false,
            },
            countries: {
                hasLimitedCountries: false,
                disableCountryFilter: params?.appId?.startsWith?.(AppStoreID.APPLE),
            },
            device: {
                disableDeviceFilter: true,
            },
        };
    },
    digitalsuite_app_appretention: (stateName, params): IFilterProps => {
        return {
            duration: {
                disableDurationFilter: params?.appId?.startsWith?.(AppStoreID.APPLE),
                presentFakeDurationFilterSingleMonth: false,
                disableWindowPreset: true,
            },
            countries: {
                hasLimitedCountries: false,
                disableCountryFilter: params?.appId?.startsWith?.(AppStoreID.APPLE),
            },
            device: {
                disableDeviceFilter: true,
            },
        };
    },
    digitalsuite_app_appdmg: (stateName, params): IFilterProps => {
        return {
            duration: {
                disableWindowPreset: true,
                disableDurationFilter: params?.appId?.startsWith?.(AppStoreID.APPLE),
            },
            countries: {
                hasLimitedCountries: false,
                disableCountryFilter: params?.appId?.startsWith?.(AppStoreID.APPLE),
            },
            device: {
                disableDeviceFilter: true,
            },
        };
    },
    digitalsuite_app_appinterests: (stateName, params): IFilterProps => {
        return {
            duration: {
                disableDurationFilter: params?.appId?.startsWith?.(AppStoreID.APPLE),
            },
            countries: {
                hasLimitedCountries: false,
                disableCountryFilter: params?.appId?.startsWith?.(AppStoreID.APPLE),
            },
            device: {
                disableDeviceFilter: true,
            },
        };
    },
    digitalsuite_marketresearch_appmarketanalysis_top: (stateName, params): IFilterProps => {
        return {
            duration: {
                disableDurationFilter: false,
            },
            countries: {
                disableCountryFilter: false,
            },
            device: {
                disableDeviceFilter: params.store.toLowerCase() === AppStoreName.GOOGLE.toLowerCase(),
            },
        };
    },
    digitalsuite_marketresearch_appmarketanalysis_trending: (stateName, params): IFilterProps => {
        return {
            duration: {
                disableDurationFilter: true,
            },
            countries: {
                disableCountryFilter: false,
            },
            device: {
                disableDeviceFilter: params.store.toLowerCase() === AppStoreName.GOOGLE.toLowerCase(),
            },
        };
    },
};

export const getAvailableFilters = (stateName, params): IFilterProps => {
    if (pagesFilters.hasOwnProperty(stateName)) {
        return pagesFilters[stateName](stateName, params);
    } else {
        return {
            duration: {
                disableDurationFilter: true,
            },
            countries: {
                hasLimitedCountries: false,
                disableCountryFilter: true,
            },
            device: {
                disableDeviceFilter: true,
            },
        };
    }
};
